@if (alertService.hasAlerts()) {
  <div class="alert-container">
    <div class="ibox" [class.collapsed]="isCollapsed">
      <div class="ibox-title">
        <h5>{{ alertService.getContainerTitle() }}</h5>
        <div class="ibox-tools">
          @if (alertService.hasScorecardAlerts()) {
            <a class="refresh-scores-link" (click)="refreshScores()" title="Refresh Scores">
              <i class="fa fa-refresh"></i>
            </a>
          }
          <a class="clear-all-link" (click)="dismissAll()" title="Clear All">
            <i class="fa fa-trash-o"></i>
          </a>
          <a class="collapse-link" (click)="toggleCollapse()">
            <i class="fa fa-chevron-up"></i>
          </a>
          <a class="close-link" (click)="dismissAll()">
            <i class="fa fa-times"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content" [style.display]="isCollapsed ? 'none' : 'block'">
        <div class="alerts-list">
          @for (alert of alertService.alerts(); track alert.id) {
            <div
              class="alert alert-dismissable"
              [class.alert-success]="alert.type === 'success'"
              [class.alert-info]="alert.type === 'info'"
              [class.alert-warning]="alert.type === 'warning'"
              [class.alert-danger]="alert.type === 'error'"
              role="alert"
            >
              <strong>{{ alert.title }}</strong> {{ alert.message }}
              @if (alert.dismissible) {
                <button
                  type="button"
                  class="close"
                  (click)="dismiss(alert.id)"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
